import { render, staticRenderFns } from "./DrugWheel.vue?vue&type=template&id=31554cec&"
import script from "./DrugWheel.vue?vue&type=script&lang=js&"
export * from "./DrugWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports